const SMALL_RANGE_RATIO = 0.02;
const MEDIUM_RANGE_RATIO = 0.05;

const getIsInRange = (
  minPrice: number,
  maxPrice: number,
  tickPrice: number,
) => {
  return tickPrice < maxPrice && tickPrice > minPrice;
};

export const createGetBarColor = (currentTickPrice: number) => {
  const getMinMaxPrices = (ratio: number) => {
    const delta = currentTickPrice * ratio;
    return [currentTickPrice - delta, currentTickPrice + delta] as const;
  };

  const minMaxPriceSmall = getMinMaxPrices(SMALL_RANGE_RATIO);
  const minMaxPriceMedium = getMinMaxPrices(MEDIUM_RANGE_RATIO);

  return (tickPrice: number) => {
    if (getIsInRange(...minMaxPriceSmall, tickPrice)) {
      return "#518ce9";
    }
    if (getIsInRange(...minMaxPriceMedium, tickPrice)) {
      return "#75acfe";
    }
    return "#adcefd";
  };
};
